import { ArticuloContact } from "../models/ArticuloContact";
import { ArticuloMO } from "../models/ArticuloMO";
import { ArticuloService } from "../services/bd/articulo/articulo.service";

//clase para gestionar los articulos y manos de obra
export class GestionArticulo
{
    //A partir de un articulo, busca la mano de obra que corresponde
    public static gestionManoObra(service:ArticuloService,token:string,art:string):Promise<any>
    {
        //Bucamos la mano de obra del cod. de articulo
        //SI se ha rellenado el articulo de mano de obra,
        //lo retornamos.
        //Si no, devolvemos false
        return new Promise<any>((resolve, reject) =>
        {
            service.getManoObraArticulo(token,art)
            .then(res=>
            {
                if(res[0])
                {
                    let mano : ArticuloContact =
                    {
                        articulo:res[0].articulo,
                        desc:res[0].descripcion,
                        central:"",
                        eurocode:"",
                        observaciones:"",
                        oem:"",
                        reg:"",
                        stkcen:0,
                        stktall:0,
                        stkReg:0,
                        taller:"",
                        campa: false,
                        sub: ""
                    }
                    resolve(mano);
                }else{
                  resolve(res);
                }
            })
            .catch(err=>
            {
                console.error(err)
                reject(false)
            });
        });
        ;
    }

    //Buscamos si dentro del listado, esta la mano de obra.
    //si no lo esta lo agregamos.
    public static agregarManoObra(listado:ArticuloContact[],artMO:ArticuloContact):ArticuloContact[]
    {
        const existe = listado.some(articulo => articulo.articulo === artMO.articulo);

        // Si no está, lo agregamos.
        if (!existe)
        {
            listado.push(artMO);
        }
        //devolvemos el listado
        return listado;
    }

    /*
        Dado un articulo,busca en el listado su mano de obra.
        si ese articulo tiene MO, quita ese articulo del listado de articulos.

        No es necesario devolver el array ya que los recoge por referencia asi que ya se modifican igualmente.
    */
    public static quitarManoObra(articulo:string, listadoMO:ArticuloMO[],listadoArt:ArticuloContact[]):ArticuloContact[]
    {
        //buscamos si hay mano de obra de ese articulo
        if(!listadoMO.some(objeto => objeto.articulo === articulo))
        {
            //SI no hay, salimos
            return listadoArt;
        }

        let mObra = listadoMO.find((artMo)=>artMo.articulo==articulo);
        if(mObra)
        {
            const index = listadoArt.findIndex((element) => element.articulo === mObra!.articulo);

            // Si se encuentra el elemento, se quita del array
            if (index > -1)
            {
                listadoArt.splice(index, 1);
                //Se debe de refrescar el datasource fuera de aqui
            }
        }
        return listadoArt;
    }
    //retorna un boolean para indicar si el articulo es o no una mano de obra
    public static esManoObra(articulo:string, listadoMO:ArticuloMO[]):boolean
    {
        //si ese articulo esta como una mano de obra, se trata de una mano de obra (duh)
        return (listadoMO.some(objeto => objeto.manoObra === articulo));
    }

  public static esCampana(articulo:string, listadocampana:ArticuloContact[]):boolean
  {
    //si ese articulo esta como una mano de obra, se trata de una mano de obra (duh)
    return (listadocampana.some(objeto => objeto.articulo === articulo));
  }

  public static esBooking(articulo:string, listadobooking:ArticuloContact[]):boolean
  {
    //si ese articulo esta como una mano de obra, se trata de una mano de obra (duh)
    return (listadobooking.some(objeto => objeto.articulo === articulo));
  }

  public static estaSeleccionado (articulo: string, listado: ArticuloContact[]): boolean{
    return (listado.some(objeto => objeto.articulo === articulo));
  }
}
